import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { redirectTo } from 'omni-package-react-core';
import DeleteMessagesButton from '../../../components/_DeleteMessagesButton';
import Constants from '../../../Constants';

export interface DeleteButtonProps {
  messageId: number;
}

const DeleteButton: FC<DeleteButtonProps> = ({ messageId }) => {
  const { t } = useTranslation('MessageDetailsPage');

  const navigate = useNavigate();
  const { search } = useLocation();
  const messageSource = new URLSearchParams(search).get('messageSource');

  return (
    <DeleteMessagesButton
      messageSource={messageSource}
      messageIds={[messageId]}
      buttonText={t('buttonDelete')}
      showCount={false}
      successMessage="MessageDetailsPage:messageDeleteSnackbar"
      handleSuccess={() => {
        redirectTo(`${Constants.BasePagePath}?messageSource=${messageSource}`, navigate);
      }}
    />
  );
};
export default DeleteButton;
